export default __webpack_public_path__ + "static/media/Leach+Film+Selects+Edited-4.a0ac0df8.jpeg";